import { createSlice, AnyAction } from '@reduxjs/toolkit'
import { ccsApi } from '../../api/ccs/react'
import { HistoryStateType } from './types'

const initialState: HistoryStateType = { versionHistory: [], versionData: null }

export const name = 'moduleHistory'

export const moduleHistorySlice = createSlice({
  name,
  initialState,
  reducers: {
    clearModuleHistory: (state) => {
      state.versionHistory = []
      state.versionData = null
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      ccsApi.endpoints.getGenericModuleVersionHistory.matchFulfilled,
      (state: HistoryStateType, action: AnyAction) => {
        const { payload: data } = action

        state.versionHistory = data
      },
    )
    builder.addMatcher(
      ccsApi.endpoints.getGenericModuleVersionData.matchFulfilled,
      (state: HistoryStateType, action: AnyAction) => {
        const { payload: data } = action
        const moduleName = Object.keys(data).filter((key) => key !== 'id')[0]
        state.versionData = data[moduleName]
      },
    )
    builder.addMatcher(
      ccsApi.endpoints.getModuleVersionHistory.matchFulfilled,
      (state: HistoryStateType, action: AnyAction) => {
        const { payload: data } = action

        state.versionHistory = data
      },
    )
    builder.addMatcher(
      ccsApi.endpoints.getModuleVersionData.matchFulfilled,
      (state: HistoryStateType, action: AnyAction) => {
        const { payload: data } = action

        state.versionData = data
      },
    )
  },
})

export const { clearModuleHistory } = moduleHistorySlice.actions

export default moduleHistorySlice.reducer
